const socialLinks = [
	{
		name: "Instagram",
		url: "https://www.instagram.com/bluedanceshortfilm?igsh=OGQ5ZDc2ODk2ZA==",
		icon: "instagram",
	},
	{
		name: "Linktree",
		url: "https://linktr.ee/elyarandrianaivo",
		icon: "linktree",
	},
	{
		name: "Vimeo",
		url: "https://vimeo.com/showcase/10526024",
		icon: "vimeo",
		size: 40,
	},
	{
		name: "Email",
		url: "mailto:someone@example.com",
		icon: "email",
		size: 40,
	},
];

export default socialLinks;
